<template>
    <div
        v-if="appParams && appParams.staticTranslations"
        id="itb-delete-box"
        v-show="isOpen"
        class="card"
    >
        <nav>
            <button class="itb-mdi-logo" @click="toggleIcon">
                <span class="mdi mdi-close"></span>
            </button>

            <span class="itb-delete-headline">
                {{ appParams.staticTranslations["carts.delete_confirmation"] }}
            </span>
        </nav>

        <div class="itb-delete-body">
            <p class="mb-4">
                {{
                    appParams.staticTranslations[
                        "carts.delete_confirmation_message"
                    ]
                }}
            </p>
            <div class="d-flex justify-content-center">
                <button
                    type="button"
                    class="btn btn-primary itb-add-to-basket"
                    @click="deleteProduct"
                >
                    {{ appParams.staticTranslations["carts.yes"] }}
                </button>
                <button
                    type="button"
                    class="btn btn-outline-primary"
                    @click="toggleIcon"
                >
                    {{ appParams.staticTranslations["carts.no"] }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "TermsAndCondition",
    props: {
        visible: Boolean,
    },

    computed: {
        isOpen: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("cancel");
                }
            },
        },

        ...mapGetters({
            appParams: "getAppParams",
        }),
    },

    data() {
        return {};
    },

    methods: {
        toggleIcon() {
            this.isOpen = !this.isOpen;
            this.$emit("cancel");
        },
        deleteProduct() {
            this.$emit("confirm");
        },
    },
};
</script>
